import React, { FC } from 'react';
import styles from './styles.module.css';
import { Typography, Button } from 'antd';
import * as translations from './strings';
import { getLangKey } from 'appJS/models/Language';
import UpgradeIcon from './assets/upgrade.svg';
import { Calendar, MessagesSquare } from 'lucide-react';
import { onContactSupport } from '../../../utils/HelpArticleButton';
import { Guide, HelpGuideCard } from '../../../components/HelpGuideCard';

const strings = translations[getLangKey()];

type Props = {
  canAccessBilling: boolean;
  organizationId: number;
  isVideoModalOpen: boolean;
  setIsVideoModalOpen: (isVideoModalOpen: boolean) => void;
  container: HTMLDivElement;
};

export const Support: FC<Props> = ({ canAccessBilling, organizationId }) => {
  return (
    <div className={styles.supportContainer}>
      <div className={styles.needHelp}>
        <Typography.Title level={3} className={styles.header}>
          {strings.needHelp}
        </Typography.Title>
        <div className={styles.buttonContainer}>
          <Button
            type="text"
            icon={<Calendar />}
            onClick={() => window.open('https://bugherd.com/book-a-demo')}
          >
            {strings.bookADemo}
          </Button>
          or
          <Button
            type="text"
            icon={<MessagesSquare />}
            className={styles.button}
            onClick={onContactSupport}
          >
            {strings.contactSupport}
          </Button>
        </div>
        <HelpGuideCard
          guide={Guide.GettingStartedChecklist}
          bubbleContent={strings.recommendedReading}
          header={strings.helpGuidesHeader}
          message={strings.helpGuidesMessage}
          guideButton={{
            link: '/collections/41522-guide-getting-started-with-bugherd',
            articleId: 11467098
          }}
          isAdminView
        />
      </div>
      <div
        className={styles.subscriptionPlanContainer}
        onClick={() => {
          const url = canAccessBilling
            ? `${window.location.origin}/settings/organizations/${organizationId}/subscription`
            : 'https://bugherd.com/pricing';
          const target = canAccessBilling ? '_self' : '_blank';
          window.open(url, target);
        }}
      >
        <div className={styles.upgradeBadge}>
          <UpgradeIcon />
          <span>{strings.upgrade}</span>
        </div>
        <Typography.Title level={3} className={styles.header}>
          {strings.chooseTheRightPlan}
        </Typography.Title>
        <span>{strings.chooseTheRightPlanDescription}</span>
        <Button type="default">{strings.exploreOurPlans}</Button>
      </div>
    </div>
  );
};
